import Collaborations from "../../components/Collaborations";
import Contact from "../../components/Contact";
import Donations from "../../components/Donation";
import FreeCourses from "../../components/FreeCourses";
import HeroSection from "../../components/HeroSection";
import MissionVisionValues from "../../components/MissionVisionValues";
import Services from "../../components/Services";
import KeyFocusAreas from '../../components/KeyFocusAreas';

export default function HomePage() {
  return (
    <div>
      <HeroSection />
      <MissionVisionValues />
      <Collaborations />
      <Services />
      <KeyFocusAreas />
      <Donations />
      <FreeCourses />
      <Contact />
    </div>
  );
}
